export default theme => ({
  container: {
    padding: 5,
  },
});
